import { FeatureName, useIsFeatureEnabled } from '@gripp/shared-logic';
import { Colors, createBaseTheme, toastConfig } from '@gripp/shared-ui';
import { ReactNode } from 'react';
import { StyleSheet, View } from 'react-native';
import { PaperProvider } from 'react-native-paper';
import Toast from 'react-native-toast-message';
import { useLocation } from 'react-router-dom';
import { Banner } from './banner';
import { Menu } from './menu';

type LayoutProps = {
  children: ReactNode;
};

export const Layout = ({ children }: LayoutProps) => {
  const isCropCircleRedesignEnabled = useIsFeatureEnabled(
    FeatureName.CropCircleRedesign
  );
  const theme = createBaseTheme(!!isCropCircleRedesignEnabled);

  // The OEM Home Dashboard renders a full-canvas map and owns its own header
  // chrome, so it wants to sit edge-to-edge against the left menu / top / bottom
  // with none of the shared content gutter every other page uses.
  const location = useLocation();
  const isFullBleed = location.pathname.startsWith('/home');

  return (
    <PaperProvider theme={theme}>
      <View style={styles.container}>
        <Menu />
        <View style={styles.row}>
          <Banner />
          <View style={[
            styles.row,
            styles.content,
            isFullBleed
              ? { padding: 0 }
              : isCropCircleRedesignEnabled
              ? { paddingHorizontal: 16 }
              : { paddingHorizontal: 40 },
          ]}>{children}</View>
        </View>
      </View>
      <Toast config={toastConfig} />
    </PaperProvider>
  );
};

const styles = StyleSheet.create({
  container: {
    flexDirection: 'row',
    flex: 1,
  },
  row: {
    flex: 1,
    flexDirection: 'column',
    backgroundColor: Colors.primaryGrayBackground,
  },
  content: {
    flex: 1,
    flexDirection: 'column',
    padding: 16,
  },
});
